import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "rewind-banners",
    ref: "stack",
    class: "rewind-banners"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, null, 512),
        _createElementVNode("div", {
            class: "rewind-banners-spacer",
            style: _normalizeStyle({ height: _ctx.height + 'px' })
        }, null, 4)
    ], 64));
}
